import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { deleteProfile, getProfile } from '../../../redux/profile/action';
import { Modal } from "reactstrap";
import AccountDeleteModel from './ProfileSettings/AccountDeleteModel';
import { urtoast } from '../../Layouts/CustomPopup/eventEmitter';
import { useNavigate } from 'react-router-dom';

export default function AccountDelete({ model, setModel }) {
    const profile = useSelector(({ profile: { profiledata } }) => profiledata);
    const dispatch = useDispatch();
    // const [model, setModel] = useState(false);
    const laung = localStorage.getItem("laung");
    const [lan, setLan] = useState(laung ?? "en");
    const [response, setResponse] = useState(null);
    const navigate = useNavigate();


    useEffect(() => {
        if (model) {
            setResponse(null); // Reset response when opening modal
            handleDelete(1);
        }
    }, [model]);


    const handleDelete = (check) => {
        const systemInfo = {
            userAgent: navigator.userAgent,
            platform: navigator.platform,
            language: navigator.language,
            screenResolution: `${window.screen.width}x${window.screen.height}`,
        };

        const data = {
            token: localStorage.getItem("urexperttoken"),
            device_type: "3",
            uuid: "",
            system_info: JSON.stringify(systemInfo),
            ...(check ? { check: 1 } : {}),
        };

        return dispatch(deleteProfile(data))
            .then((response) => {
                setResponse(response?.data);
                console.log(response?.data, 'Account delete response');

                if (check != 1) {
                    // Show success message
                    urtoast("Account deleted successfully.", 1);

                    // Call logout after 2 seconds (2000 ms)
                    setTimeout(() => {
                        LogoutMethod();
                    }, 2000);
                }
                return response?.data;
            })
            .catch((error) => {
                urtoast(error?.message || "Something went wrong.", 2);
                throw error;
            });
    };


    const LogoutMethod = () => {
        localStorage.removeItem("urexperttoken");
        localStorage.removeItem("role_type");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("urlState");
        dispatch(getProfile());
        navigate(`/${lan}/`);
        window.location.reload()
    };


    return (
        <>
            <Modal
                className="popupmodal logout"
                isOpen={model}
                toggle={() => setModel((state) => !state)}
            >
                <AccountDeleteModel
                    handleDelete={handleDelete}
                    setModel={setModel}
                    response={response}
                />
            </Modal>
        </>
    );
}
